import "bootstrap"
import "@fortawesome/fontawesome-free/js/all"
import './photos';
